import { Button, Group, Text } from '@mantine/core'
import { ShortageOrder, ShortageTableItem } from 'types/shortage'

type Props = {
  shortages: Array<ShortageTableItem>
  existingShortageOrders: Array<ShortageOrder>
  goToCreateNewOrder: () => void
  goToAddToExistingOrder: () => void
}

export default function ThereIsExistingOrder({
  existingShortageOrders,
  goToCreateNewOrder,
  goToAddToExistingOrder,
}: Props) {
  return (
    <>
      <Text>
        {existingShortageOrders.length === 1
          ? 'Istnieje już niezrealizowane zamówienie dla tego produktu. '
          : `Istnieją już ${existingShortageOrders.length} niezrealizowane zamówienia dla tego produktu. `}
        Możesz stworzyć nowe zamówienie lub dodać brakujące produkty do jednego z istniejących zamówień. Co chcesz
        zrobić?
      </Text>
      <Group mt="sm" grow>
        <Button my="md" onClick={goToCreateNewOrder} variant="light">
          Stwórz nowe
        </Button>
        <Button my="md" onClick={goToAddToExistingOrder} variant="light">
          Dodaj do istniejącego
        </Button>
      </Group>
    </>
  )
}
